import React, { useEffect } from 'react';
import './App.css';
import Admin from './Admin';

function App() {
  const isAdminRoute = window.location.pathname === '/admin';

  useEffect(() => {
    if (!isAdminRoute) {
      window.location.href = '/game/index.html';
    }
  }, [isAdminRoute]);

  if (isAdminRoute) {
    return <Admin />;
  }

  return (
    <div className="App">
      <div className="loading-screen">
        <h1>BEARWORLD</h1>
        <p>Loading your Arctic adventure...</p>
      </div>
    </div>
  );
}

export default App;
